<template>
    <PasswordExpired></PasswordExpired>
</template>

<script>
    import PasswordExpired from "../components/PasswordExpired";

    export default {
        name: "password-expired-page",
        components: {
            PasswordExpired,
        }
    };
</script>